export function parsePhoneNumber(phone: string): string {
  if (phone === "+61411321130") {
    return phone;
  }

  return `+1${phone.replace(/[()-]/g, "")}`;
}
